import { Link, NavLink, Outlet } from 'react-router-dom';
import { WatercolorBloom } from './WatercolorBloom';

export function AppShell() {
  return (
    <div className="app-shell">
      <TopBar />
      <main style={{ flex: 1, padding: '32px 0 80px' }}>
        <div className="container">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}

function TopBar() {
  return (
    <header style={{ position: 'relative', borderBottom: '1px solid var(--c-border-soft)', background: 'rgba(255,255,255,0.5)', backdropFilter: 'blur(12px)' }}>
      <WatercolorBloom variant="magenta" size={280} style={{ position: 'absolute', top: -120, left: -60 }} opacity={0.25} />
      <WatercolorBloom variant="cyan"    size={240} style={{ position: 'absolute', top: -100, right: -40 }} opacity={0.22} />
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 72, position: 'relative' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, color: 'inherit' }}>
          <Logo />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 900, fontSize: 22, letterSpacing: '0.02em' }} className="gradient-text">ATLAS</span>
            <span className="label" style={{ fontSize: 9, marginTop: -2 }}>Paint the future of every trip</span>
          </div>
        </Link>
        <nav style={{ display: 'flex', gap: 4, flexWrap: 'wrap', justifyContent: 'flex-end' }} className="tabs">
          <NavLink to="/"          end className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>Trips</NavLink>
          <NavLink to="/calendar"        className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>Calendar</NavLink>
          <NavLink to="/mileage-sweet-spot" className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>Mileage Sweet Spot</NavLink>
          <NavLink to="/insurance"      className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>Insurance</NavLink>
          <NavLink to="/new"             className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>New</NavLink>
          <NavLink to="/settings"        className={({isActive}) => `tab ${isActive ? 'active' : ''}`}>Settings</NavLink>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer style={{ borderTop: '1px solid var(--c-border-soft)', padding: '24px 0', background: 'rgba(255,255,255,0.4)' }}>
      <div className="container row-between">
        <span className="label">// Atlas v0.1 — Cyberpunk Watercolor</span>
        <span className="label">Signal stable.</span>
      </div>
    </footer>
  );
}

function Logo() {
  // Small holographic A glyph
  return (
    <svg width={36} height={36} viewBox="0 0 36 36" aria-hidden>
      <defs>
        <linearGradient id="a-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"  stopColor="#FF2BD6" />
          <stop offset="50%" stopColor="#7B5CFF" />
          <stop offset="100%" stopColor="#00F0FF" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="32" height="32" rx="9" fill="url(#a-grad)" opacity="0.18" />
      <path d="M9 28 18 7l9 21M12 22h12" stroke="url(#a-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
